
// import React, { useEffect, useState } from 'react';
// import Table from 'react-bootstrap/Table';
// import Navbar from '../../Components/Navbar';
// import '../Secretary/Table.css';
// import axios from 'axios';
// import { Modal, Button } from 'react-bootstrap';
// import { API_BASE_URL } from '../../config';

// export default function ApproveBudget() {
//   const [applications, setApplications] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [modalMessage, setModalMessage] = useState('');

//   useEffect(() => {
//     // Fetch applications from the PHP script
//     fetchApplications();
//   }, []);

//   const fetchApplications = async () => {
//     try {
//       // Use axios for a GET request
//       const response = await axios.get('/ApproveBudget.php');
//       // Set the fetched data to state variables
//       setApplications(response.data);
//     } catch (error) {
//       console.error('Error fetching applications:', error);
//     }
//   };

//   // Handle the decision change
//   const handleDecisionChange = (id, newDecision) => {
//     const updatedApplications = applications.map((app) =>
//       app.app_ID === id ? { ...app, decision: newDecision } : app
//     );
//     setApplications(updatedApplications);
//   };

//   // Save decision for the given application id
//   const saveDecision = async (id) => {
//     const app = applications.find(app => app.app_ID === id);
//     try {
//       // Send the decision to the backend to be saved in the database
//       const response = await axios.post('/ApproveBudget.php', {
//         app_ID: app.app_ID,
//         decision: app.decision,
//       });

//       if (response.data.status === 'success') {
//         console.log(`Decision "${app.decision}" saved for application ${id}`);
//         fetchApplications(); // Refresh the application list after saving the decision
//         setModalMessage(`Decision "${app.decision}" was saved successfully!`);
//         setShowModal(true);  // Show the modal with the success message
//       } else {
//         console.error('Failed to save decision');
//         setModalMessage('Failed to save decision');
//         setShowModal(true);  // Show the modal with the error message
//       }
//     } catch (error) {
//       console.error('Error saving decision:', error);
//       setModalMessage('Error saving decision');
//       setShowModal(true);  // Show the modal with the error message
//     }
//   };

//   const handleView = (id, reportType) => {
//     console.log(`Viewing ${reportType} budget report for application ${id}`);
  
//     // Prepare the URL for requesting the budget file
//     const downloadUrl = `${API_BASE_URL}/ApproveBudget.php?app_ID=${id}&reportType=${reportType}`;
  
//     // Trigger the download request
//     axios
//       .get(downloadUrl, { responseType: 'blob' }) // Specify 'blob' as responseType to handle file
//       .then((response) => {
//         // Create a link element to trigger the download
//         const link = document.createElement('a');
//         const blob = new Blob([response.data], { type: 'application/pdf' }); // Create blob with received data
//         link.href = URL.createObjectURL(blob); // Create an object URL for the blob
//         link.download = `${reportType}_budget_${id}.pdf`; // Set the filename for download
//         link.click();  // Trigger the download
  
//         // Clean up the object URL
//         URL.revokeObjectURL(link.href);
//       })
//       .catch((error) => {
//         console.error('Error fetching the file:', error);
//         alert('An error occurred while trying to download the file.');
//       });
//   };
  

//   return (
//     <div>
//       <Navbar />
//       <h1 className="page-title">Approve Budget Revision</h1>
//       <Table striped bordered hover>
//         <thead>
//           <tr>
//             <th>Project Title</th>
//             <th>Application Id</th>
//             <th>Request Date</th>
//             <th>Previous Budget</th>
//             <th>Current Budget</th> {/* Updated here */}
//             <th>Decision</th>
//             <th>Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {applications.map((app) => (
//             <tr key={app.app_ID}>
//               <td>{app.projectTitle}</td>
//               <td>{`${app.Id}_${new Date().getFullYear()}`}</td>
//               <td>{app.uploaded_at}</td>
//               <td>
//                 <button
//                   className="view-button"
//                   onClick={() => handleView(app.Id, 'previous')}
//                 >
//                   View
//                 </button>
//               </td>
//               <td>
//                 <button
//                   className="view-button"
//                   onClick={() => handleView(app.Id, 'current')}
//                 >
//                   View
//                 </button>
//               </td>
//               <td>
//                 <select
//                   value={app.decision}
//                   onChange={(e) => handleDecisionChange(app.app_ID, e.target.value)}
//                   className='dropdown'
//                 >
//                   <option value="Pending">Pending</option>
//                   <option value="Approved">Approved</option>
//                   <option value="Rejected">Rejected</option>
//                 </select>
//               </td>
//               <td>
//                 <button
//                   className="view-button"
//                   onClick={() => saveDecision(app.app_ID)}
//                 >
//                   Save
//                 </button>
//               </td>
//             </tr>
//           ))}
//           {applications.length === 0 && (
//             <tr>
//               <td colSpan={6}>No applications available</td>
//             </tr>
//           )}
//         </tbody>
//       </Table>

//       {/* Modal for showing the decision status */}
//       <Modal show={showModal} onHide={() => setShowModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Decision Saved</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>{modalMessage}</Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowModal(false)}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }
import React, { useEffect, useState } from 'react';
import Table from 'react-bootstrap/Table';
import Navbar from '../../Components/Navbar';
import '../Secretary/Table.css';
import axios from 'axios';
import { Modal, Button } from 'react-bootstrap';
import { API_BASE_URL } from '../../config';

export default function ApproveBudget() {
  const [applications, setApplications] = useState([]);
  const [filteredApplications, setFilteredApplications] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [fileExists, setFileExists] = useState({}); // State to track file existence
  const [selectedYear, setSelectedYear] = useState('');

  const currentYear = new Date().getFullYear();
  const startYear = 2024;
  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => startYear + i
  ).reverse();

  useEffect(() => {
    fetchApplications();
  }, []);

  const fetchApplications = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/ApproveBudget.php`);
      if (Array.isArray(response.data)) {
        setApplications(response.data);
        if (selectedYear === '') {
          setFilteredApplications(response.data);
        } else {
          setFilteredApplications(
            response.data.filter((app) => {
              const appYear = new Date(app.uploaded_at).getFullYear();
              return appYear === parseInt(selectedYear);
            })
          );
        }
      } else {
        console.error('Unexpected data format:', response.data);
        setApplications([]);
        setFilteredApplications([]);
      }
    } catch (error) {
      console.error('Error fetching applications:', error);
      setModalMessage('Error fetching applications');
      setShowModal(true);
      setApplications([]);
      setFilteredApplications([]);
    }
  };

  useEffect(() => {
    // Re-filter when selectedYear changes (after initial fetch)
    if (applications.length > 0) {
      if (selectedYear === '') {
        setFilteredApplications(applications);
      } else {
        setFilteredApplications(
          applications.filter((app) => {
            const appYear = new Date(app.uploaded_at).getFullYear();
            return appYear === parseInt(selectedYear);
          })
        );
      }
    }
  }, [selectedYear, applications]);

  // Check file existence for a specific app_ID and fileType
  const checkFileExistence = async (app_ID, fileType) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/CheckFileExistence.php?app_ID=${app_ID}&fileType=${fileType}`
      );
      return response.data.exists;
    } catch (error) {
      console.error(`Error checking file existence for ${fileType}:`, error);
      return false;
    }
  };

  // Check file existence for all applications
  useEffect(() => {
    const fileTypes = ['projectBudget', 'budgetRevision'];

    const checkFilesForAllApps = async () => {
      const updatedFileExists = {};
      for (const app of applications) {
        updatedFileExists[app.app_ID] = {};
        for (const fileType of fileTypes) {
          const exists = await checkFileExistence(app.app_ID, fileType);
          updatedFileExists[app.app_ID][fileType] = exists;
        }
      }
      setFileExists(updatedFileExists);
    };

    if (applications.length > 0) {
      checkFilesForAllApps();
    }
  }, [applications]);

  const handleDecisionChange = (id, newDecision) => {
    const updatedApplications = applications.map((app) =>
      app.app_ID === id ? { ...app, decision: newDecision } : app
    );
    setApplications(updatedApplications);
    // Also update filteredApplications to reflect the change
    setFilteredApplications((prev) =>
      prev.map((app) => (app.app_ID === id ? { ...app, decision: newDecision } : app))
    );
  };

  const saveDecision = async (id) => {
    const app = applications.find((app) => app.app_ID === id);
    try {
      const response = await axios.post(`${API_BASE_URL}/ApproveBudget.php`, {
        app_ID: app.app_ID,
        decision: app.decision,
      });

      if (response.data.status === 'success') {
        console.log(`Decision "${app.decision}" saved for application ${id}`);
        fetchApplications(); // Refresh the application list
        setModalMessage(`Decision "${app.decision}" was saved successfully!`);
        setShowModal(true);
      } else {
        console.error('Failed to save decision:', response.data.message);
        setModalMessage('Failed to save decision');
        setShowModal(true);
      }
    } catch (error) {
      console.error('Error saving decision:', error);
      setModalMessage('Error saving decision');
      setShowModal(true);
    }
  };

  const handleView = (id, reportType) => {
    console.log(`Viewing ${reportType} budget report for application ${id}`);
    const downloadUrl = `${API_BASE_URL}/ApproveBudget.php?app_ID=${id}&reportType=${reportType}`;
    axios
      .get(downloadUrl, { responseType: 'blob' })
      .then((response) => {
        // Check if the response indicates an error (e.g., file not found)
        if (response.headers['content-type'].includes('application/json')) {
          response.data.text().then((text) => {
            const json = JSON.parse(text);
            alert(json.message || 'An error occurred while trying to download the file.');
          });
        } else {
          const link = document.createElement('a');
          const blob = new Blob([response.data], { type: 'application/pdf' });
          link.href = URL.createObjectURL(blob);
          link.download = `${reportType}_budget_${id}.pdf`;
          link.click();
          URL.revokeObjectURL(link.href);
        }
      })
      .catch((error) => {
        console.error('Error fetching the file:', error);
        alert('An error occurred while trying to download the file.');
      });
  };

  return (
    <div>
      <Navbar />
      <h1 className="page-title">Approve Budget Revision</h1>
      <div className="year-filter">
        <label htmlFor="year-select">Year: </label>
        <select
          id="year-select"
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
          className="year-select"
        >
          <option value="">Select Year</option>
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Project Title</th>
            <th>Application Id</th>
            <th>Request Date</th>
            <th>Previous Budget</th>
            <th>Current Budget</th>
            <th>Decision</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredApplications.map((app) => (
            <tr key={app.app_ID}>
              <td>{app.projectTitle}</td>
              <td>{`${app.app_ID}_${new Date().getFullYear()}`}</td>
              <td>{app.uploaded_at}</td>
              <td>
                <Button
                  className="view-button"
                  onClick={() => handleView(app.app_ID, 'previous')}
                  disabled={!fileExists[app.app_ID]?.projectBudget}
                  style={
                    !fileExists[app.app_ID]?.projectBudget
                      ? {
                          backgroundColor: '#859ed0ff', // Light blue-gray background
                          color: '#080707ff', // Gray text
                          border: 'none',
                          borderRadius: '4px',
                          padding: '6px 12px',
                          cursor: 'not-allowed',
                          fontSize: '14px',
                          width: '120px',
                          opacity: '0.7',
                          transition: 'background-color 0.3s ease, box-shadow 0.2s ease',
                          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                        }
                      : {}
                  }
                >
                  {fileExists[app.app_ID]?.projectBudget ? 'View' : 'Not Available'}
                </Button>
              </td>
              <td>
                <Button
                  className="view-button"
                  onClick={() => handleView(app.app_ID, 'current')}
                  disabled={!fileExists[app.app_ID]?.budgetRevision}
                  style={
                    !fileExists[app.app_ID]?.budgetRevision
                      ? {
                          backgroundColor: '#859ed0ff', // Light blue-gray background
                          color: '#080707ff', // Gray text
                          border: 'none',
                          borderRadius: '4px',
                          padding: '6px 12px',
                          cursor: 'not-allowed',
                          fontSize: '14px',
                          width: '120px',
                          opacity: '0.7',
                          transition: 'background-color 0.3s ease, box-shadow 0.2s ease',
                          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                        }
                      : {}
                  }
                >
                  {fileExists[app.app_ID]?.budgetRevision ? 'View' : 'Not Available'}
                </Button>
              </td>
              <td>
                <select
                  value={app.decision}
                  onChange={(e) => handleDecisionChange(app.app_ID, e.target.value)}
                  className="dropdown"
                >
                  <option value="Pending">Pending</option>
                  <option value="Approved">Approved</option>
                  <option value="Rejected">Rejected</option>
                </select>
              </td>
              <td>
                <Button
                  className="view-button"
                  onClick={() => saveDecision(app.app_ID)}
                >
                  Save
                </Button>
              </td>
            </tr>
          ))}
          {filteredApplications.length === 0 && (
            <tr>
              <td colSpan={7}>No applications available</td>
            </tr>
          )}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Decision Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}